import React from "react";
import Eyebrow from "./Eyebrow";

const capabilities = [
  {
    number: "01",
    title: "Data & analytics",
    desc:
      "Excel, SQL, Power BI, Python and the decision practices that turn data into value.",
  },
  {
    number: "02",
    title: "Product & design",
    desc:
      "Product management, user experience, research and cross-functional product delivery.",
  },
  {
    number: "03",
    title: "Software & AI",
    desc:
      "Software development, artificial intelligence and practical automation for modern workflows.",
  },
  {
    number: "04",
    title: "Business execution",
    desc:
      "Business analysis, project management, growth and technology-enabled operations.",
  },
];

const CapabilityAreasSection = () => {
  return (
    <section
      className="bg-[#fff9eb] py-[78px] lg:py-[105px] px-[18px] sm:px-[max(26px,50vw-640px)]"
      style={{
        backgroundImage:
          "linear-gradient(#05079409 1px, #0000 1px), linear-gradient(90deg, #05079409 1px, #0000 1px)",
        backgroundSize: "64px 64px",
      }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-mba-heading items-end gap-5 lg:gap-20 mb-12">
        <div>
          <Eyebrow>CAPABILITY AREAS</Eyebrow>
          <h2 className="text-primary tracking-[-0.045em] font-bold m-0 text-[36px] sm:text-corp-h2 leading-[1.12]">
            Build the skills behind modern organisations.
          </h2>
        </div>
        <p className="text-[#555b6e] m-0 text-[17px] leading-[1.8]">
          Current consulting capability areas reflected by Utiva include:
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {capabilities.map((cap) => (
          <article
            key={cap.title}
            className="flex flex-col rounded-[21px] border border-[#e6dcc3] bg-white/[0.96] min-h-[245px] sm:min-h-[280px] p-7 shadow-corp-collection-card"
          >
            <span className="text-[#9a6500] tracking-[0.05em] text-sm font-850">
              {cap.number}
            </span>
            <h3 className="text-primary tracking-[-0.025em] font-bold mt-12 mb-[11px] text-[22px] leading-[1.32]">
              {cap.title}
            </h3>
            <p className="text-[#555b6e] m-0 text-base leading-[1.72]">
              {cap.desc}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default CapabilityAreasSection;
